import React from 'react';
import PropTypes from 'prop-types';
import lstrings from '../../../../../../../utils/LStrings';
import {
	flatMap,
	forEach,
	orderBy, 
	groupBy,
    map,
} from 'lodash';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import TableUtils from '../../../../../../../utils/TableUtils';
import TablePlain from '../../../../../../../components/table-plain/TablePlain';
import 'react-bootstrap-table/css/react-bootstrap-table.css';

class TableDomesticos extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			data: this.processData(props.data.datos, props.tipoVisualizacion),
			tipoVisualizacion: props.tipoVisualizacion,
		};
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			data: this.processData(nextProps.data.datos, nextProps.tipoVisualizacion),
			tipoVisualizacion: nextProps.tipoVisualizacion,
		});
	}

	/**
	 * Proceso la información de Aportes Empleados Domésticos para ser visualizada
	 */
	processData = (data, tipoVisualizacion) => {
		if (data == null)
			return null;

		let info = {};

		forEach(data, (domesticoItem) => {
			let cuil = undefined;
			let nombre = undefined;
			switch (tipoVisualizacion) {
				case "empleado":
					cuil = domesticoItem.cuilEmpleador;
					nombre = domesticoItem.nombreEmpleador;
					break;
					
				case "empleador":
					cuil = domesticoItem.cuilEmpleado;
					nombre = domesticoItem.nombreEmpleado;
					break;
				
				default:
					return undefined;
			}

			// Inicialización de objetos para el año correspondiente al ítem actual
			if (!info[cuil]) {
				// Creo la entrada del año correspondiente
				info[cuil] = domesticoItem;
				info[cuil].cuil = cuil;
				info[cuil].nombre = nombre;
				info[cuil].rest = [];
			}
			else {
				info[cuil].rest.push(domesticoItem);
			}
		});

		let result = flatMap(info, (item) => item);
		
		return result;
	}


	expandedRow = (row) => {
		return <TablePlain
			columns={[
				this.tituloColumnaNombre(),
				lstrings.cuil,
				lstrings.periodo,
				lstrings.modoliquidacion,
				lstrings.aporte
			]}
			rows={map(row.rest, (item, ix) =>
				<tr key={ix}>
					<td>{this.seleccionarNombre(item)}</td>
					<td>{TableUtils.cuilFormat(this.seleccionarCuil(item))}</td>
					<td>{TableUtils.dateFormat(item.periodo)}</td>
					<td>{item.detalle}</td>
					<td>{TableUtils.ARSFormat(item.aporte)}</td>
				</tr>)}
		/>;
	}

	shouldExpandRow = (row) => {
		return row.rest.length > 0;
	}

	/**
	 * Proceso la información de Aportes Empleados Domésticos para ser visualizada
	 */
	seleccionarCuil = (item) => {
		switch (this.state.tipoVisualizacion) {
			case "empleado":
				return item.cuilEmpleador;
				
			case "empleador":
				return item.cuilEmpleado;
			
			default:
				return undefined;
		}
	}

	/**
	 * Proceso la información de Aportes Empleados Domésticos para ser visualizada
	 */
	seleccionarCuilField = () => {
		switch (this.state.tipoVisualizacion) {
			case "empleado":
				return 'cuilEmpleador';
				
			case "empleador":
				return 'cuilEmpleado';
			
			default:
				return undefined;
		}
	}

	/**
	 * Proceso la información de Aportes Empleados Domésticos para ser visualizada
	 */
	seleccionarNombre = (item) => {
		switch (this.state.tipoVisualizacion) {
			case "empleado":
				return item.nombreEmpleador;
			
			case "empleador":
				return item.nombreEmpleado;
			
			default:
				return undefined;
		}
	}

	/**
	 * Proceso la información de Aportes Empleados Domésticos para ser visualizada
	 */
	seleccionarNombreField = () => {
		switch (this.state.tipoVisualizacion) {
			case "empleado":
				return 'nombreEmpleador';
			
			case "empleador":
				return 'nombreEmpleado';
			
			default:
				return undefined;
		}
	}

	/**
	 * Proceso la información de Aportes Empleados Domésticos para ser visualizada
	 */
	tituloColumnaNombre = () => {
		switch (this.state.tipoVisualizacion) {
			case "empleado":
				return lstrings.empleador;
			
			case "empleador":
				return lstrings.empleado;
			
			default:
				return undefined;
		}
	}
	
	gridOptions = () => {
		return TableUtils.defaultConfig();
	}

	plusButtonFormat = (cell) => {
		if (cell.length > 0)
			return TableUtils.plusButtonFormat();
	}



    render() {
		return (
			<BootstrapTable data={this.state.data}
				expandableRow={this.shouldExpandRow}
				expandComponent={this.expandedRow}
				options={this.gridOptions()}>
				<TableHeaderColumn
					dataField="rest"
					width='30'
					dataFormat={this.plusButtonFormat}
				></TableHeaderColumn>
				
				<TableHeaderColumn
					dataField='nombre'
					isKey
				>{this.tituloColumnaNombre()}</TableHeaderColumn>
				
				<TableHeaderColumn
					dataField='cuil'
					dataFormat={TableUtils.cuilFormat}
				>{lstrings.cuil}</TableHeaderColumn>
				
				<TableHeaderColumn
					dataField='periodo'
					dataFormat={TableUtils.dateFormat}
				>{lstrings.periodo}</TableHeaderColumn>
				
				<TableHeaderColumn
					dataField='detalle'
				>{lstrings.modoliquidacion}</TableHeaderColumn>
				
				<TableHeaderColumn
					dataField='aporte'
					dataFormat={TableUtils.ARSFormat}
				>{lstrings.aporte}</TableHeaderColumn>
			</BootstrapTable>
        );
	}
}

TableDomesticos.propTypes = {
    data: PropTypes.any,
    onRequestInfo: PropTypes.func
};

export default TableDomesticos;



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/panel-datos-laborales/components/TableDomesticos.js